/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SectionFragmentType {
    Unknown = 1,
    FrameOverlay = 2,
    RoofTrim = 3,
    Stubbed = 4,
    Splinter = 5,
    Cheeks = 6,
    Frame = 7,
    FrameSurroundingRod = 8,
    AreaFragment = 9,
}
